module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/financial-unit-lvl1-100.e08ef929.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/financial-unit-lvl1-100.png
// module id = 3525
// module chunks = 11